<template>
  <el-dialog width="433px"
             append-to-body
             :visible.sync="visible"
             :show-close="false"
             :close-on-click-modal="false"
             :close-on-press-escape="false"
             class="scheduling-dialog"
             custom-class="safe-tips__dialog">
    <div class="scheduling-header">
      <img src="./tips.png">
    </div>
    <div class="scheduling-body">
      您好！您有下属当前月份还未排班，请及时处理。
    </div>
    <div class="scheduling-footer">
      <kye-button type="primary"
                  class="btn"
                  @click="goScheduling">去排班</kye-button>
    </div>
  </el-dialog>
</template>

<script>
  import moment from 'moment'

  export default {
    name: 'scheduling',
    data () {
      return {
        visible: false
      }
    },
    mounted () {
      this.$bus.$once('GLOBAL_DIALOG_NEXT:scheduling', this.getNoSchedulingCount)
    },
    methods: {
      // 获取当月，直接下属未排班的个数
      async getNoSchedulingCount () {
        let res = await this.$http('hr.attendanceScheduleMonth.noSchedulingCount', {
          // 当前登录人id
          employeeId: this.$store.state.user.id,
          // 当月 月份
          month: moment().format('YYYY-MM')
        })
        if (res) {
          this.visible = true
        } else {
          this.$bus.$emit('GLOBAL_DIALOG_NEXT:questionnaire')
        }
      },
      // 去排班
      goScheduling () {
        this.visible = false
        this.$router.push(`/hr/scheduling-information/list`)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .safe-tips__dialog {
    &.el-dialog {
      background: rgba(0, 0, 0, 0);
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0);
    }
    .el-dialog__header {
      display: none;
    }
    .el-dialog__body {
      padding: 0;
    }
    &__header {
      height: 164px;
      background-image: url("../../shared/assets/images/safe-tip-bg.png");
      position: relative;
      h3 {
        position: absolute;
        top: 136px;
        left: 20px;
        color: #fff;
        font-size: 20px;
        font-weight: bold;
        letter-spacing: 4px;
      }
    }
    &__body {
      padding: 12px 16px;
      background-color: #fff;
      // border-radius: 0 0 2px 2px;
      overflow-y: auto;
      max-height: calc(70vh - 280px);
      line-height: 1.5;
    }
    &__footer {
      // text-align: center;
      background-color: #fff;
    }
  }
  .scheduling-dialog {
    .el-dialog__body {
      border-radius: 4px;
    }
    .scheduling-header {
      img {
        width: 100%;
      }
    }
    .scheduling-body {
      background-color: #fff;
      height: 130px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: -3px;
    }
    .scheduling-footer {
      padding-bottom: 20px;
      background-color: #fff;
      display: flex;
      justify-content: center;

      .btn {
        width: 106px;
        height: 32px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/layout/components/scheduling.vue